import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DocumentTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "Document",
      path: "/admin/document"
    },
    {
      label: "Legal Settings",
      path: "/admin/legalsettings/add"
    },
    {
      label: "NDAs",
      path: "/admin/nda/add"
    },
   
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default DocumentTabs;